import React from 'react';

import api from '@/api';
import Layout from '@/components/Layout';
import InternalServerError from '@/components/Pages/InternalServerError';
import MyProfile from '@/components/Pages/MyProfile';
import { useUpdateUserProfileMutation } from '@/generated/graphql';
import withProfileCreated from '@/hoc/withProfileCreated';
import { useAuth } from '@/hooks/useAuth';
import { getAuthType } from '@/types/auth';

import type { NextPage } from 'next';

const MyProfilePage: NextPage = () => {
  const { authModel, updateAuthModel, logout } = useAuth();
  const [updateUserProfile] = useUpdateUserProfileMutation();

  if (authModel.state === `profile-created`) {
    const email = authModel.auth0user.email ?? ``;
    const resetPassword = () => {
      return api.resetPassword(email);
    };
    const submit = async (props: {
      firstName: string;
      lastName: string;
      phonenumber: string;
      consentedToMarketing: boolean;
    }) => {
      const { data } = await updateUserProfile({
        variables: {
          updateUserProfileInput: {
            firstName: props.firstName,
            lastName: props.lastName,
            phoneNumber: props.phonenumber,
          },
          consentedToMarketing: props.consentedToMarketing,
        },
      });

      if (data && data.updateUserProfile.error) {
        throw Error(data.updateUserProfile.error);
      }

      if (data && data.consentToMarketing.error) {
        throw Error(data.consentToMarketing.error);
      }

      updateAuthModel();
    };
    const [yyyy, mm, dd] = authModel.user.dateOfBirth.split(`-`);

    return (
      <Layout headerType={`float`}>
        <MyProfile
          email={email}
          onSubmit={submit}
          authType={getAuthType(authModel.auth0user)}
          resetPassword={resetPassword}
          yyyy={yyyy}
          mm={mm}
          dd={dd}
          firstName={authModel.user.firstName}
          lastName={authModel.user.lastName}
          phonenumber={authModel.user.phoneNumber}
          consentedToMarketing={authModel.user.consentedToMarketing}
          logout={logout}
        />
      </Layout>
    );
  }

  return <InternalServerError />;
};

export default withProfileCreated(MyProfilePage);
